import { BehaviorSubject, Subscription, interval, tap } from 'rxjs';

import { DestroyRef, Injectable, effect, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoggerService } from '../logger/logger.service';

@Injectable({
    providedIn: 'root',
})
export class HeartbeatService {
    readonly #destroyRef = inject(DestroyRef);
    readonly #logger = inject(LoggerService);

    #heartbeatSub: Subscription | null = null;
    #lastHeartbeat = new BehaviorSubject<Date | null>(null);

    intervalMs = signal(1000);
    lastHeartbeat = signal<Date>(new Date());
    lastHeartbeat$ = this.#lastHeartbeat.asObservable();

    constructor() {
        effect(() => {
            this.#restartHeartbeat();
        });
    }

    setIntervalMs(newInterval: number) {
        this.#logger.verbose(
            '`Heartbeat Service (setIntervalMs) ->',
            newInterval,
        );
        this.intervalMs.set(newInterval);
    }

    #restartHeartbeat() {
        if (this.#heartbeatSub) {
            this.#heartbeatSub.unsubscribe();
        }

        this.#heartbeatSub = interval(this.intervalMs())
            .pipe(
                tap(() => {
                    const timestamp = new Date();
                    this.#logger.verbose(
                        '`Heartbeat Service (interval) ->',
                        timestamp,
                    );
                    this.lastHeartbeat.set(timestamp);
                    this.#lastHeartbeat.next(timestamp);
                }),
                takeUntilDestroyed(this.#destroyRef),
            )
            .subscribe();
    }
}
